import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContextWeb } from "../context/AuthContextWeb";

export default function ProtectedRoute({ allowRoles = [] }) {
  const { isAuthenticated, user } = useContext(AuthContextWeb);
  const location = useLocation();
  const normalizedUserRole =
    typeof user?.role === "string" ? user.role.toUpperCase() : "";
  const normalizedAllowRoles = allowRoles.map((role) =>
    String(role).toUpperCase(),
  );

  if (!isAuthenticated) {
    return <Navigate to="/app/login" state={{ from: location }} replace />;
  }

  if (
    normalizedAllowRoles.length > 0 &&
    !normalizedAllowRoles.includes(normalizedUserRole)
  ) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
